import { render, staticRenderFns } from "./TostaoForm.vue?vue&type=template&id=c43dfae0"
import script from "./TostaoForm.vue?vue&type=script&lang=js"
export * from "./TostaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports